import { render, staticRenderFns } from "./ProfileUploadDocument.vue?vue&type=template&id=0dd66ed6&scoped=true&"
import script from "./ProfileUploadDocument.vue?vue&type=script&lang=js&"
export * from "./ProfileUploadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd66ed6",
  null
  
)

export default component.exports